module.exports = __webpack_public_path__ + "static/hospital_support_top_imgM@2x-d045fdbd74f3e3f15401344040d1700c.png";